jQuery(document).ready(function($) {
  var isShown = false;
  if($('.wf-phone-chat-sim').length) {

    $(window).scroll(function() {
      if(isScrolledIntoView('.wf-phone-chat-sim') && !isShown) {
        // console.log('bang');
        isShown = true;
        displayChat();
      }
    });

  }

  function displayChat() {
    var counter = 0;
    var messageGap = 500;
    var messageEndPause = 4000;

    // Display message thread
    $('.wf-phone-chat-sim .phone-scroll > div').each(function() {
      var delay = parseInt($(this).attr('data-delay'));
      var messageWrap = $(this);
      var message = $(this).find('.message');
      var typing =  $(this).find('.typing');

      setTimeout(function() {
        messageWrap.removeClass('hide');
        // console.log('fire wrapper', counter + delay);
        setTimeout(function() {
          typing.addClass('hide');
          message.addClass('active');
          // console.log('fire message', delay);
        }, delay);
      }, counter + messageGap);

      counter += delay;
      counter += messageGap;
    });

    // reset
    // setTimeout(function() {
    //   $('.wf-phone-chat-sim .phone-scroll > div').each(function() {
    //     $(this).addClass('hide');
    //     $(this).find('.message').removeClass('active');
    //     $(this).find('.typing').removeClass('hide');
    //     // displayChat();
    //   });
    // }, counter + messageEndPause);
  }
});
